export default {
    "accountValidateMsg" : "账号必须为6-30位字符，包括字母、数字、“.”、“_”、“@”，第一位字符仅能为数字或字母。",
    "storeSuccess" : "储值成功",
    "editAccountTips" : "请输入有效账号",
    "editPwdTips" : "请输入有效密码",
    "editRepeatPwdTips" : "请重复输入密码",
    "pwdRepeatTips" : "两次密码不匹配",
    "changePwdSucc" : "修改密码成功",
    "bindEmail" : "绑定邮箱",
    "errorVrifyCodeTips" : "验证码错误",
    "slectQuessionTips" : "请选择安全问题",
    "answerTips" : "请输入答案",
    "twoAnswerTips" : "请选择两个您已经设置的安全问题，并输入正确答案。",
    "realNameValidateTips" : "请输入4~60位的真实姓名",
    "phoneValidateTips" : "请输入6～18位数字的电话号码",
    "areaSelectTips" : "请选择正确的国家地区",
    "iDCardValidataTips" : "请输入1~60位的身份证号码",
    "changeProfileSucc" : "信息编辑成功",
    "editVrfCodeTips" : "请输入验证码",
    "securityQuestionTips" : "请设置您的安全问题，提升您的账号安全。当您忘记密码时，可以通过回答安全问题快速重置密码。",
    "validateQuessionTips" : "请选择两个不同的问题并进行认证，认证完成后便可重置安全问题。",
    "originPwd" : "请输入旧密码",
    "newPwd" : "请输入新密码",
    "changePwdSuccess" : "修改密码成功，请手动重新登入账号，防止数据丢失",
    "accountName" : "请输入帐号名称",
    "password" : "请输入密码",
    "repeatPassword" : "请再重复密码",
    "findPwdTips" : "请输入您需要找回密码的帐号名称",
    "submit" : "提交",
    "send" : "发送",
    "modify" : "修改",
    "haveAgree" : "我已同意",
    "and" : "和",
    "privacyPolicy" : "隐私策略",
    "completeness" : "资料完成度:",
    "gender" : "性别",
    "male" : "男",
    "female" : "女",
    "birthday" : "生日",
    "phone" : "联系电话",
    "region" : "国家／地区",
    "ID" : "护照或身份证号码",
    "accountSetting" : "账号设置",
    "upgrade" : "账号升级",
    "profile" : "个人资料",
    "changePassword" : "修改密码",
    "securityQuestion" : "安全问题",
    "creatework_headerTitle" : "创建工单",
    "mylist_headerTitle" : "我的工单",
    "bindEmailTips" : "请认证一个您的常用邮箱，提升您的账号安全。当您忘记密码时，可通过此邮箱快速重置密码。",
    "enterEmailVrfcationTips" : "请输入收到的验证码",
    "cancel" : "取消",
    "bindTps" : "选择账户绑定的方式可以让你在数台设备中以您的账号来进行游戏!",
    "login" : "登入",
    "logout" : "登出",
    "bind" : "帐户绑定",
    "feedback" : "问题反馈",
    "terms" : "相关条款",
    "tips" : "提示",
    "guestSwitchTips" : "您当前已经有游客账户存在，登录后当前游客账户会丢失，请问确认要登录吗？",
    "register" : "注册",
    "realName" : "真实姓名",
    "enterEmailTips" : "请输入邮箱地址",
    "emailVAlidateMsg" : "邮箱格式错误",
    "editEmaileTips" : "请输入邮箱",
    "checkServiceTips" : "请先阅读并接受服务条款和隐私政策！",
    "brithdayValidateTips" : "请选择正确的生日",
    "facebookValidateTips" : "请输入1~60位的facebook账号",
    "eritOriginPwdTips" : "请输入原密码",
    "submitSuccess" : "提交成功",
    "rebindEmail" : "修改邮箱",
    "bindEmailSuccess" : "您已成功绑定邮箱\$email</br>使用已绑定邮箱进行认证，认证完成便可重置邮箱。",
    "reSetSecurityQuessoon" : "您已经成功设置安全问题<br/><br/>选择不同的问题并进行认证，认证完成后便可重置问题",
    "canotModifyTips" : "个人资料信息提交后将不能更改，是否提交？",
    "rebindEmailTips" : "您的邮箱 \$email,请点击获取验证码并输入您收到的验证码",
    "reGetVrfCode" : "获取验证码",
    "findPwdWayTips" : "请选择以下方式找回",
    "emailWay" : "通过安全邮箱找回",
    "emailWayTips" : "你将收到一封确认邮件，可以重新设置密码。",
    "quessionWay" : "通过安全问题找回",
    "quessionWayTips" : "回答已经设置的安全问题，可以重新设置密码。",
    "resetPwdBtn" : "重置密码",
    "lastStep" : "上一步",
    "sendEmailTips" : "我们已经向您的认证邮箱\$email发送确认邮件。<br>请将您收到的验证码正确填入对话框中。",
    "setNewPwdTips" : "恭喜！<br>您可以重新设置密码了，请在对话框中输入您的新密码吧！",
    "termsOfUse" : "服务条款",
    "creatework_create" : "工单类",
    "creatework_createHolder" : "请选择类型",
    "creatework_title" : "标题",
    "creatework_titleHolder" : "请输入标题",
    "creatework_detail" : "问题详情",
    "creatework_detailHolder" : "请输入200字以内的问题详情",
    "creatework_uploadTips" : "只能上传jpg/png格式文件，文件不能超过5mb",
    "creatework_selectBox_selectTile" : "问题类型",
    "creatework_goGame" : "返回游戏",
    "creatework_history" : "工单历史",
    "mylist_noYet" : "您还没有任何工单记录喔",
    "mywork_solved" : "问题已解决了？点我",
    "mywork_service" : "给客服评分",
    "mywork_messageHolder" : "请输入新消息",
    "mywork_score" : "请选择评分",
    "mywork_confirm" : "确认",
    "creatework_selectBox_selectList3" : "其他问题",
    "creatework_selectBox_selectList2" : "帐号问题",
    "creatework_gameHolder" : "请选择游戏",
    "creatework_serverHolder" : "请选择服务器",
    "contactService" : "联系客服",
    "creatework_game" : "游戏：",
    "creatework_server" : "伺服器：",
    "creatework_role" : "角色：",
    "selectRoleName" : "请选择角色",
    "creatework_noRole" : "还没有创建角色",
    "creatework_noGame" : "游戏列表为空",
    "creatework_noServer" : "服务器列表为空",
    "termText" : "我已同意37GAMES平台",
    "backLogin" : "返回登录",
    "creatework_roleHolder" : "请选择角色后再访问",
    "findPwdFailTips" : "您没有设置安全问题和安全邮箱，无法通过这种方式找回，请联系客服。",
    "payMall" : "储值商城",
    "selectPayment" : "选择金额",
    "plzSelectPayWay" : "请选择您的渠道",
    "gainPlus" : "加码",
    "gainMorePlus" : "加码多多",
    "gainMostPlus" : "最高加码",
    "plzSelectPayType" : "选择储值方式",
    "roleName" : "角色名",
    "payWay" : "支付渠道",
    "plzSelectOtherWay" : "选择其他支付渠道",
    "payment" : "支付金额",
    "compensateTips" : "超出商品价值部分将额外补偿\$gameCode给您",
    "extaGain" : "额外获得",
    "gameGold" : "游戏币",
    "compensate" : "补偿",
    "payWayPlus" : "渠道加码",
    "neddPay" : "需支付",
    "submitOrder" : "提交订单",
    "screenshotTips" : "温馨提示：截图保存订单信息，后续遇到问题方便反馈哦！",
    "storeFail" : "储值失败",
    "storeFailTips" : "非常抱歉本次储值失败了，请您尝试重新提交订单，或通过客服工单联系我们",
    "storeAcceptance" : "受理中",
    "storeSuccessTips" : "储值成功后通常在15MIN内到账，请稍后于游戏内查看",
    "orderNumber" : "订单号",
    "buyProduct" : "储值商品",
    "transactionAmount" : "交易金额",
    "failReason" : "失败原因",
    "payOntherORder" : "再储一笔",
    "reStore" : "重新储值",
    "confirm" : "确定",
    "switch" : "帐号切换",
    "completeTips" : "请填写您的个人资料， 以下信息<mark class=\"yellowMarkC`olor\">填写后将不允许修改</mark>.当您的账号丟失或被盗用时，可通过向客服提供准确的个人资料信息作为取回账号的依据。",
    "creatework_selectBox_selectList0" : "游戏问题",
    "creatework_selectBox_selectList1" : "支付问题",
    "creatework_selectBox_selectList4" : "翻译问题",
    "mywork_solvedText" : "问题已解决",
    "browserPayErrBtnText" : "交易遇到问题",
    "browserPaySucBtnText" : "已完成支付",
    "browserPayingTips" : "您正在前往第三方平台进行支付,<br/>完成支付后即可关闭此页面。",
    "price_list_empty" : "无可选金额",
    "pointCardTips" : "注意：商品仅支持等于 \$paymentAmount 的 点卡购买",
    "forgetPwd" : "忘记密码",
    "payCenter" : "平台储值中心",
    "willGet" : "您将获得",
    "goods" : "商品",
    "discount" : "额外赠送",
    "payDiscount" : "支付补偿",
    "payDiscountTips" : "超出商品价格将进行支付补偿",
    "hasQuestionPlease" : "如有疑问，请",
    "pwdValidateMsg" : "密码必须为6-20位字符",
    "payWayPlusC" : "渠道赠送",
    "fwtk" : "服务条款",
    "yszc" : "隐私政策",
    "exchange" : "礼包码兑换",
    "remember" : "记住我",
    "thirdInfo" : "账号规则说明",
    "thirdInfoContent" : "请在游戏内的用户中心完成账号绑定，再使用绑定的账号进行登录。",
    "unLink" : "暂不支持此方式",
    "favour" : "收藏游戏",
    "goStoreTip" : "请跳转前往储值页面",
    "go" : "前往",
    "otherLogin" : "其它登录方式",
    "qrCodeTip" : "扫一扫二维码,马上开启旅程吧!",
    "favourTip" : "收藏页面到浏览器,方便下次再玩喔~",
    "share" : "分享给朋友",
    "landscapeTip" : "请用竖屏方式进行操作",
    "leaveTip" : "您真的要离开游戏吗？",
    "selectRole" : "请选择您要充值的角色",
    "selectMoney" : "请选择想购买的道具",
    "seletGameInfoFirst" : "请先选择游戏信息",
    "lowerIE" : "您的ie版本过低",
    "linkTermText" : "我已同意37games平台<服务条款>和<隐私政策>",
    "download" : "下载",
    "favourAndDownloadTip" : "收藏到浏览器或者下载到电脑<br/>方便下次再玩",
    "payReward" : "支付有奖",
    "hasEqualReward" : "两种支付方式同享首充双倍等优惠",
    "payBtnText" : "支付",
    "storeHoaveReward" : "充值优惠",
    "showMorePayWay" : "展开更多支付方式",
    "needPaymentCount" : "需要支付金额",
    "orderDetail" : "订单详情",
    "selectPayWayPlz" : "选择支付方式",
    "-" : "-"
}